<template>
  <div>
    <div
      class="btn-group"
      :class="{ 'w-100': position == 'aside' }"
      role="group"
      aria-label="Выбор способа входа на сайт">
      <template v-for="(el, index) in types">
        <input
          v-if="el.active"
          :key="`input-${el.title}`"
          :name="`formLoginSelect`"
          :value="index"
          v-model="selected"
          :title="el.descr"
          type="radio"
          class="btn-check"
          :id="`btnradiologin${index}`"
          autocomplete="off" />
        <label
          v-if="el.active"
          :key="`label-${el.title}`"
          class="btn btn-outline-secondary"
          :for="`btnradiologin${index}`"
          ><font-awesome-icon :icon="`fa-solid ${el.icon}`" />
          <span :class="{ 'd-none': position == 'aside' }"> {{ el.title }}</span></label
        >
      </template>
    </div>
    <div class="comment-wrapper" :class="{ 'comment-wrapper_small': position == 'aside' }">
      {{ types[selected].descr }}
    </div>
    <component :is="types[selected].component" :csrf="csrf" :position="position" :links="links" />
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faAt, faUserTie, faPhone } from '@fortawesome/free-solid-svg-icons';
library.add(faAt, faUserTie, faPhone);

import formLoginUsername from './login/form-login-username.vue';
import formLoginEmail from './login/form-login-email.vue';
import formLoginSms from './login/form-login-sms.vue';

export default {
  data: function () {
    return {
      selected: null,
      types: [
        {
          title: 'ID клиента',
          descr: 'Вход с помощью ID клиента (логина) и пароля.',
          icon: 'fa-user-tie',
          component: 'formLoginUsername',
          active: true,
        },
        {
          title: 'Эл. почта',
          descr: 'Вход с помощью кода, отправленного на эл. почту.',
          icon: 'fa-at',
          component: 'formLoginEmail',
          active: true,
        },
        {
          title: 'Телефон',
          descr: 'Вход с помощью кода, отправленного в смс.',
          icon: 'fa-phone',
          component: 'formLoginSms',
          active: true,
        },
      ],
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: '',
    },
    links: {
      type: Object,
      default: () => {},
    },
  },
  components: { FontAwesomeIcon, formLoginUsername, formLoginEmail, formLoginSms },
  created() {
    this.types.find((el, index) => {
      if (el.active) {
        this.selected = index;
        return true;
      }
    });
  },
};
</script>

<style lang="scss">
.comment-wrapper {
  line-height: 1.1;
  margin-top: 0.5rem;
  margin-bottom: 0.75rem;

  &_small {
    font-size: 0.875rem;
  }
}
</style>
